"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ValidationBRError extends Error {
}
exports.default = ValidationBRError;
ValidationBRError.INVALID_DV = new ValidationBRError('Dígito verificador inválido');
ValidationBRError.EMPTY_VALUE = new ValidationBRError('Valor não preenchido');
ValidationBRError.MAX_LEN_EXCEDEED = new ValidationBRError('Número de caracteres excedido');
ValidationBRError.SEQUENCE_REPEATED = new ValidationBRError('Sequência de números repetidos não permitida');
//# sourceMappingURL=ValidationBRError.js.map